import { createContext, useContext } from "react";
import type { Workspace, WorkspaceSummary } from "../../api/types";

export interface WorkspaceContextValue {
  /** The workspace in the URL (`/w/:workspaceId`), as the API returned it for this user. */
  readonly workspace: Workspace;
  /** Every workspace of the user (switcher). */
  readonly workspaces: readonly WorkspaceSummary[];
  /** Replace the current workspace after a successful mutation. */
  setWorkspace(workspace: Workspace): void;
  /** Re-fetch the workspace and the list. */
  reload(): Promise<void>;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

export function useWorkspace(): WorkspaceContextValue {
  const value = useContext(WorkspaceContext);
  if (!value) throw new Error("useWorkspace() must be used inside the workspace shell");
  return value;
}

/** Like `useWorkspace()` but `null` outside the shell (widgets that also render standalone). */
export function useOptionalWorkspace(): WorkspaceContextValue | null {
  return useContext(WorkspaceContext);
}
